import { render, staticRenderFns } from "./ventas.vue?vue&type=template&id=dc95e3ae&"
import script from "./ventas.vue?vue&type=script&lang=js&"
export * from "./ventas.vue?vue&type=script&lang=js&"
import style0 from "./ventas.vue?vue&type=style&index=0&id=dc95e3ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports